module.exports = __webpack_public_path__ + "img/play-solid.0e500cb1.svg";